export interface CallsConnectionAuthorityRecord {
  readonly connection: string;
  readonly authority: string;
  readonly governed: boolean;
}

const CALLS_CONNECTION_AUTHORITIES: readonly CallsConnectionAuthorityRecord[] =
Object.freeze([
  {
    connection: 'direct-connection',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    connection: 'family-group-connection',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    connection: 'scheduled-connection',
    authority: 'Calls Governor',
    governed: true,
  },
  {
    connection: 'emergency-connection',
    authority: 'Calls Governor',
    governed: true,
  },
]);

export function getCallsConnectionAuthorities():
readonly CallsConnectionAuthorityRecord[] {
  return CALLS_CONNECTION_AUTHORITIES;
}
